import styled from 'styled-components';
import { Dropdown } from '@trevor/ui-components';

export const DropdownContent = styled(Dropdown.Content).attrs({ top: 50 })`
  border: 1px solid #dfe3e7;
  border-radius: var(--radius-8);
  background-color: #fff;
  width: 100%;
  z-index: 2;

  > div {
    padding: var(--spacing-m);
    cursor: pointer;

    :hover {
      background-color: var(--color-interface-layout-lighter);
    }

    &.selected-chart-configuration {
      background-color: var(--color-interface-layout-lighter);
    }
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-m);
  border: 1px solid #dfe3e7;
  border-radius: var(--radius-8);
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  > svg:first-child {
    margin-right: var(--spacing-s);
    cursor: grab;
  }

  > span + svg {
    margin-left: auto;
  }
`;

export const DisabledDropdownTrigger = styled(DropdownItem)`
  cursor: not-allowed;
  background-color: #dfe3e7;
`;
